import React from "react";

const Image = ({ webpSrc, otherSrc, className, onClick }) => {
  return <img className={className} src={webpSrc} alt="" onClick={onClick} />;
};

export default Image;
